import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../app/hooks";
import { Talent, talentIsDeactivated } from "../../talents/talentAPI";
import { selectTalentById } from "../../talents/talentsSlice";
import TalentHrEezyReview from "./TalentHrEezyReview";

type Props = {
  isLoading: boolean;
};

const TalentHr = ({ isLoading }: Props) => {
  const params = useParams();
  const talentId = params.talentId as string;

  const talent = useAppSelector((state) =>
    selectTalentById(state, talentId),
  ) as Talent;

  return (
    <Grid container item xs={9} maxWidth="1200px" padding="7px 20px 16px 20px">
      <TalentHrEezyReview
        talent={talent}
        disableEdit={talentIsDeactivated(talent)}
      />
    </Grid>
  );
};

export default TalentHr;
